import { AppBar, Toolbar, Button, Container, Box, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { useAuth } from '@/contexts/AuthContext';
import { usePoints } from '@/contexts/PointsContext';
import { useEffect, useState } from 'react';
import AuthDialog from '@/components/auth/AuthDialog';
import UserMenu from './UserMenu';

export default function Header() {
  const { isAuthenticated, logout, isLoading } = useAuth();
  const { balance, updateBalance } = usePoints();
  const [mounted, setMounted] = useState(false);
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [authDialogMode, setAuthDialogMode] = useState<'login' | 'register'>('login');

  const handleOpenAuthDialog = (mode: 'login' | 'register') => {
    setAuthDialogMode(mode);
    setAuthDialogOpen(true);
  };

  useEffect(() => {
    console.log('Header component mounting - Current auth state:', { isAuthenticated, isLoading });
    setMounted(true);
    if (isAuthenticated && !isLoading) {
      updateBalance();
    }
  }, [isAuthenticated, isLoading, updateBalance]);

  useEffect(() => {
    console.log('Header mounted state changed:', mounted);
  }, [mounted]);

  const renderAuthButtons = () => {
    if (!mounted || isLoading) {
      return null;
    }

    return isAuthenticated ? (
      <>
        <Box>
          <UserMenu />
        </Box>
      </>
    ) : (
      <>
        <Button color="inherit" variant="outlined" onClick={() => handleOpenAuthDialog('login')}>
          Login
        </Button>
        <Button color="secondary" variant="contained" onClick={() => handleOpenAuthDialog('register')} sx={{ ml: 1 }}>
          Register
        </Button>
        <AuthDialog
          open={authDialogOpen}
          onClose={() => setAuthDialogOpen(false)}
          initialMode={authDialogMode}
        />
      </>
    );
  };

  return (
    <AppBar position="sticky" color="primary" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Container>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Link href="/" style={{ display: 'inline-block' }}>
              <Image
                src="/logo.png"
                alt="Extensive Rewards"
                width={180}
                height={40}
                priority
              />
            </Link>
          </Box>
          {renderAuthButtons()}
        </Toolbar>
      </Container>
    </AppBar>
  );
}